interface GenerateRequest {
  youtube_url: string;
  generate_book: boolean;
  include_images: boolean;
  generate_mcq: boolean;
  generate_glossary: boolean;
  generate_mindmap: boolean;
}

interface GenerateResponse {
  data: {
    pdf_url?: string;
    book_pdf_url?: string;
    mcq_pdf_url?: string;
    mindmap_pdf_url?: string;
    glossary_pdf_url?: string;
    mcq_json_url?: string;
    message?: string;
    status?: string;
  };
  status: string;
}

export class APIError extends Error {
  constructor(
    message: string,
    public status?: number,
    public code?: string
  ) {
    super(message);
    this.name = 'APIError';
  }
}

export async function generateStudyMaterial(request: GenerateRequest): Promise<GenerateResponse> {
  try {
    console.log('Sending request:', request);

    const response = await fetch('/api/proxy/generate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(request),
    });

    console.log('Response status:', response.status);

    if (!response.ok) {
      let errorMessage = 'Failed to generate study material';
      try {
        const errorData = await response.json();
        console.error('Error data:', errorData);
        errorMessage = errorData.message || errorMessage;
      } catch {
        errorMessage = response.statusText || errorMessage;
      }
      throw new APIError(errorMessage, response.status);
    }

    const rawData = await response.json();
    console.log('Raw API Response:', rawData);

    // Transform the response to match our expected format
    const data: GenerateResponse = {
      status: rawData.status || 'success',
      data: {
        message: rawData.message,
        status: rawData.status,
        pdf_url: rawData.book_pdf_url, // Main PDF is the book PDF
        book_pdf_url: rawData.book_pdf_url,
        mcq_pdf_url: rawData.mcq_pdf_url,
        mcq_json_url: rawData.mcq_json_url,
        mindmap_pdf_url: rawData.mindmap_pdf_url,
        glossary_pdf_url: rawData.glossary_pdf_url,
      }
    };

    console.log('Processed Response:', data);
    
    return data;
  } catch (error) {
    console.error('Error generating study material:', error);
    
    if (error instanceof APIError) {
      throw error;
    }
    
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      throw new APIError(
        'Unable to connect to the server. Please check your internet connection or try again later.',
        0,
        'NETWORK_ERROR'
      );
    }

    throw new APIError('An unexpected error occurred. Please try again later.');
  }
} 